//===============================================================================================================
// SCA Model: ContactUs.Model
//===============================================================================================================
define('ContactUs.Model',
    [
        'Backbone',
        'underscore',
        'Utils'
    ],
    function (
        Backbone,
        _,
        Utils
    )
    {
        'use strict';

        //================================================================
        // Backbone Model Definition
        //
        // To use a cached model, use "BackboneCachedModel.extend" instead
        //================================================================
        return Backbone.Model.extend({
            urlRoot: Utils.getAbsoluteUrl('services/ContactUs.Service.ss'),

            //----------------------------------------------------------------
            // Backbone.Validation structure to validate model fields
            //----------------------------------------------------------------
            validation: {
                reason: { required: true, msg: _('Reason is required').translate() },
                name: { required: true, msg: _('First and Last Name is required').translate() },
                email: { required: true, pattern: 'email', msg: _('Email is required').translate() },
                message: { required: true, msg: _('Message is required').translate() }
            }
        });
    }
);

